export default __webpack_public_path__ + "static/media/OpdBg.412d7386.svg";